import { render, staticRenderFns } from "./EdenTag.vue?vue&type=template&id=4fccfa52"
import script from "./EdenTag.vue?vue&type=script&lang=js"
export * from "./EdenTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports